import React, { useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LoginContent } from '../../components/PagesContent/LoginContent';
import { Spinner } from '../../components/Spinner';
import { eightAuth } from '../../store/eightauth';

const Login = () => {
  const dispatch = useDispatch();

  const isLoginLoading = useSelector(eightAuth.loginLoadingSelector);

  const [loginEmail, setLoginEmail] = useState('');
  const [loginPassword, setLoginPassword] = useState('');
  const [keepSignedIn, setKeepSignIn] = useState(false);

  const handleEmailChange = useCallback(
    (e) => {
      setLoginEmail(e);
    },
    [setLoginEmail]
  );

  const handlePasswordChange = useCallback(
    (e) => {
      setLoginPassword(e);
    },
    [setLoginPassword]
  );

  const handleLoginClick = useCallback(
    (form) => {
      dispatch(
        eightAuth.loginAsync.request({
          username: form.loginEmail,
          password: form.loginPassword,
        })
      );
    },
    [dispatch]
  );

  const handleKeepSignIn = useCallback(
    (e) => {
      const { checked } = e.target;
      setKeepSignIn(checked);
    },
    [setKeepSignIn]
  );

  return (
    <>
      {isLoginLoading && <Spinner />}
      <LoginContent
        loginEmail={loginEmail}
        loginPassword={loginPassword}
        handleEmailChange={handleEmailChange}
        handlePasswordChange={handlePasswordChange}
        handleLoginClick={handleLoginClick}
        handleKeepSignIn={handleKeepSignIn}
        keepSignedIn={keepSignedIn}
      />
    </>
  );
};

export default Login;
